(function () {
    'use strict';

    angular
        .module('ib-ancillaries-transfers-globick-module')
        .controller('AncillariesTransfersGlobickController', AncillariesTransfersGlobickController);

    AncillariesTransfersGlobickController.$inject = ['$window', '$rootScope', '$timeout', 'CommonsSessionStorageService', 'MenusConstants', 'localStorageService', '$scope', 'DatalayerUtilsService', 'DatalayerMenusService'];
    function AncillariesTransfersGlobickController ($window, $rootScope, $timeout, CommonsSessionStorageService, MenusConstants, localStorageService, $scope, DatalayerUtilsService, DatalayerMenusService) {
        const vm = this;
        vm.removeTransfersGlobick = removeTransfersGlobick;

        /**
         * Remove transfers globick from basket.
         */
        function removeTransfersGlobick () {
            $timeout(() => {
                $rootScope.$broadcast('deleteGlobickTransfers');
                const transferGlobick = CommonsSessionStorageService.get('removeGlobickTransfers');
                vm.basketFunctions.isLoading();
                vm.basketFunctions.deleteAncillariesService.deleteAncillarie(transferGlobick).then(() => {
                    deleteTransfersGlobickSucess();
                    $rootScope.$broadcast('basketUpdateCommonHeader');
                }, (error) => {
                    vm.basketFunctions.isNotLoading();
                    vm.basketFunctions.modalService.setErrorMessage(error.message);
                    vm.basketFunctions.modalService.setErrorCode(error.internalErrorCode);
                    vm.basketFunctions.modalService.isError(error);
                    vm.basketFunctions.collapseHeader.closeCollapse();
                });
                CommonsSessionStorageService.remove('removeGlobickTransfers');
            });
        }

        function deleteTransfersGlobickSucess (actualPage) {
            vm.model.info = null;
            vm.model.hasTransfersGlobick = false;
            vm.basketFunctions.calculateAllBasket(actualPage);
            vm.basketFunctions.saveHeaderModel();
            vm.basketFunctions.isNotLoading();
        }
    }
})();
